var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first"},[_c('div',{staticClass:"center-box"},[_c('p',{staticClass:"title"},[_vm._v("合作客户")]),_c('div',{staticClass:"customer"},[_c('img',{attrs:{"src":require("@/assets/customer.png")}})])])])
}]

export { render, staticRenderFns }